<template>
  <modal :name="nombreModal" :adaptive="true" height="auto" width="520px">
    <div class="conf">
      <div class="modal-header conf-cabecera">
        <h4>{{ $t("ordenPrimeroTitulo") }}</h4>
      </div>

      <div class="modal-body conf-cuerpo">
        <p class="conf-error ord-texto">{{ $t("ordenPrimeroTexto") }}</p>
      </div>

      <div class="modal-footer conf-pie">
        <button type="button" class="btn btn-claro" @click="cerrar()">
          {{ $t("cancelar") }}
        </button>
        <button type="button" class="btn btn-claro" @click="elegir('continuar')">
          {{ $t("continuarIgualmente") }}
        </button>
        <button type="button" class="btn btn-verde" @click="elegir('reordenar')">
          {{ $t("reordenarPrimero") }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
/**
 * Aviso que se pone delante de cualquier otra accion de la pantalla mientras haya
 * terminales con las categorias en otras teclas que el servidor.
 *
 * No bloquea: el usuario puede seguir, pero sabiendo que con las teclas cruzadas la
 * accion puede escribir donde no toca. Lo recomendado -reordenar primero- es el boton
 * principal.
 *
 * Emite `reordenar` o `continuar` DESPUES de cerrarse, para que la pantalla pueda abrir
 * el modal siguiente sin que se pisen.
 */
export default {
  name: "OrdenPrimeroModal",

  props: {
    nombreModal: { type: String, default: "modalOrdenPrimero" }
  },

  methods: {
    abrir() {
      this.$modal.show(this.nombreModal);
    },

    cerrar() {
      this.$modal.hide(this.nombreModal);
    },

    elegir(evento) {
      this.cerrar();
      this.$nextTick(() => this.$emit(evento));
    }
  }
};
</script>

<style scoped>
@import "../confirmar-en-modal.css";

/* El error de siempre, pero como cuerpo del modal y no como pie de un formulario. */
.ord-texto {
    margin: 0;
    font-size: 0.9em;
    line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/pages/Widgets/Categorias/OrdenPrimeroModal.vue